import { Stack } from '@mui/material';
import { FormTextField } from 'src/components/Forms/FormTextField/form-text-field';
import {
  BLOCK_LONG_TEXTAREA_PROPS,
  BLOCK_TEXT_FIELD_PROPS,
} from 'src/pages/Settings/memberships/components/landing-page-tab/block-fields/field-props';
import { ImageUrlField } from 'src/pages/Settings/memberships/components/landing-page-tab/block-fields/image-url-field';
import { SegmentedToggleField } from 'src/pages/Settings/memberships/components/landing-page-tab/segmented-toggle-field';
import {
  blockFieldName,
  MEDIA_POSITION_OPTIONS,
} from 'src/pages/Settings/memberships/components/landing-page-tab/types';

interface ContentBlockFieldsProps {
  index: number;
  readOnly: boolean;
}

export const ContentBlockFields = ({ index, readOnly }: ContentBlockFieldsProps) => {
  return (
    <Stack gap={2.5}>
      <FormTextField
        type="textfield"
        name={blockFieldName(index, 'contentKicker')}
        label="Kicker"
        disabled={readOnly}
        textFieldProps={BLOCK_TEXT_FIELD_PROPS}
      />

      <FormTextField
        type="textfield"
        name={blockFieldName(index, 'contentTitle')}
        label="Title"
        required="Title is required"
        disabled={readOnly}
        textFieldProps={BLOCK_TEXT_FIELD_PROPS}
      />

      <FormTextField
        type="textfield"
        name={blockFieldName(index, 'contentBody')}
        label="Body"
        disabled={readOnly}
        textFieldProps={BLOCK_LONG_TEXTAREA_PROPS}
      />

      <SegmentedToggleField
        name={blockFieldName(index, 'contentMediaPosition')}
        label="Media position"
        options={MEDIA_POSITION_OPTIONS}
        readOnly={readOnly}
      />

      <ImageUrlField index={index} prefix="content" label="Image URL" readOnly={readOnly} />
    </Stack>
  );
};
